// src/pages/ComingSoonPage.jsx (actualizado)
import React from 'react';
import ComingSoon from '../components/ComingSoon';
import { useNavigate } from 'react-router-dom';

const ComingSoonPage = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return <ComingSoon onLoginClick={handleLoginClick} />;
};

export default ComingSoonPage;
